import {action, makeAutoObservable, observable, reaction} from 'mobx';
import {selectedCompanyStore} from "./SelectedCompany";
import {customerApi} from "../backend/CustomerApi";
import {CustomerDto} from "../model/customer/Customer";
import {Nil} from "../utils/Types";
import {logEvent} from "../utils/SentryUtils";
import {userInfoStore} from "./UserInfo";

class CustomersStore {
    @observable fetched: boolean = false;
    readonly customers = observable<CustomerDto>([])

    constructor() {
        makeAutoObservable(this);
    }

    @action
    public async invalidate() {
        this.fetched = false;
    }

    public find = (id: string | Nil) => {
        return this.customers.find(it => it.id === id);
    }

    @action
    public async refresh() {
        if (selectedCompanyStore.isSelected && userInfoStore.isAuthorized && !this.fetched) {
            this.customers.replace(await customerApi.fetchCustomers());
            this.fetched = true;
            logEvent("customer", "Customers fetched")
        }
    }
}

export const customersStore = new CustomersStore();

reaction(
    () => selectedCompanyStore.companyId,
    () => customersStore.invalidate()
)

reaction(
    () => userInfoStore.email,
    () => customersStore.invalidate()
)
